import Vue from "vue";
export const EventHub = new Vue();
